import axios from '../axios';
const END_POINT = '/units';

const addUnit = (unit) => axios.post(`${END_POINT}`, unit);
const getUnits = (payload) => axios.get(`${END_POINT}?limit=${payload.limit}&page=${payload.page}`);
const getOneUnit = (unitId) => axios.get(`${END_POINT}/${unitId}`);
const updateUnit = (unitId, payload) => axios.patch(`${END_POINT}/${unitId}`, payload);
const searchUnit = (payload) => axios.post(`${END_POINT}/search`, payload);
const searchUnitForCurrentUser = (payload) => axios.post(`${END_POINT}/search-for-current-user`, payload);
const deleteUnit = (unitsId) => axios.delete(`${END_POINT}/${unitsId}`);
const getSelectedMonitoringDoctors = (unitId) => axios.get(`${END_POINT}/find-all-selected-user-for-unit-monitoring/${unitId}`);
const findAllUsersForUnitMonitoring = (unitId) => axios.get(`${END_POINT}/find-all-user-for-unit-monitoring/${unitId}`);
const updateForShowMonitoringDoctors = (unitId,payload) => axios.patch(`${END_POINT}/show-monitoring-users/${unitId}`, payload);

export {
    addUnit,
    getUnits,
    getOneUnit,
    updateUnit,
    searchUnit,
    deleteUnit,
    searchUnitForCurrentUser,
    getSelectedMonitoringDoctors,
    updateForShowMonitoringDoctors,
    findAllUsersForUnitMonitoring,
}
